module.exports = __webpack_public_path__ + "static/wpack/extracted/icon--cocospace-light67bb194d8892b8285dcdb3751cecc7a7.svg";